// Register GSAP plugin and set defaults
gsap.registerPlugin(ScrollTrigger);

// ==========================================
// kg-4-btn-w-text-intro 
// ==========================================

document.addEventListener('DOMContentLoaded', async () => {
  const hasPlayedAnimation = sessionStorage.getItem('hasPlayedAnimation');
  const tlthick = gsap.timeline({ defaults: { overwrite: 'auto' } });

  const resetElements = () => {
    gsap.set(".kg-heading-h2, .kg-heading-h3, .rotate-four", { opacity: 0 });
  };

  resetElements();

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        tlthick.fromTo(".kg-heading-h2", { opacity: 0 }, { opacity: 1, duration: 0.7 })
          .fromTo(".kg-heading-h3", { opacity: 0 }, { opacity: 1, duration: 0.7 }, "-=0.5")
          .fromTo(".rotate-four", { x: -500, opacity: 0 }, { x: 0, opacity: 1, duration: 0.7, stagger: 0.5, ease: 'power3.out' }, "-=0.5");

        sessionStorage.setItem('hasPlayedAnimation', 'true');
        observer.unobserve(entry.target);
      }
    });
  });

  observer.observe(document.querySelector('.rotate-box-four'));

  window.addEventListener('beforeunload', () => {
    sessionStorage.removeItem('hasPlayedAnimation');
  });
});

// ==========================================
// 3-face-thick-text-hp.js 
// ==========================================

// gsap.defaults({ ease: "none", duration: 2 });

// Arrow animation
let arrow = document.querySelector('.arrow');
if (arrow) {
  gsap.to(arrow, { y: 12, ease: "power1.inOut", repeat: -1, yoyo: true, duration: 0.5 });
}

// ❌ Highlight text animation code commented out
/*
document.addEventListener('DOMContentLoaded', function () {
  import('https://cdn.skypack.dev/split-type@0.3.3').then(({ default: SplitType }) => {
    const tlthick = gsap.timeline();
    const splitText = SplitType.create('h1.highlight-text, h2.highlight-text', { types: 'words' });
    const splitWords = splitText.words;

    const observer = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          tlthick.fromTo(".highlight-text", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            ease: 'linear'
          });

          splitWords.forEach(function (item, index) {
            const width = item.offsetWidth;
            const dur = (width / 100) / 7;

            tlthick.fromTo(item, {
              backgroundPosition: "100%"
            }, {
              duration: dur,
              ease: 'linear',
              stagger: index * 0.1,
              backgroundPosition: "0"
            });
          });

          tlthick.fromTo("p:not(.no-animation)", {
            opacity: 0,
          }, {
            opacity: 1,
            duration: 1,
            ease: 'power1.out',
          });

          observer.unobserve(entry.target);
        }
      });
    });

    observer.observe(document.querySelector('.highlight-text'));
  });
});
*/

// ==========================================
// kg-three-img-text-hp.js 
// ==========================================

function createTextRevealAnimation(section) {
  const tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 75%",
      once: true,
      end: "bottom top",
      toggleActions: "play none none reset",
    }
  });

  const allLinks = gsap.utils.toArray("p");
  const kgNum = section.querySelector(".kg-num");
  const lineOne = section.querySelector(".one");
  const lineTwo = section.querySelector(".two");
  const lineThree = section.querySelector(".three");
  const button = section.querySelector(".buy-fire");
  const image = section.querySelector(".k-column-right img");

  const isReversed = section.classList.contains("reverse");

  if (isReversed) {
    gsap.set([kgNum, lineOne, lineThree], { xPercent: 101, autoAlpha: 0 });
    gsap.set(lineTwo, { xPercent: -101, autoAlpha: 0 });
    gsap.set(image, { autoAlpha: 0 });
    gsap.set(button, { xPercent: 0, autoAlpha: 0, scale: 0.75 });
  } else {
    gsap.set([kgNum, lineOne, lineThree], { xPercent: -101, autoAlpha: 0 });
    gsap.set(lineTwo, { xPercent: 101, autoAlpha: 0 });
    gsap.set(button, { xPercent: 0, autoAlpha: 0, scale: 0.75 });
    gsap.set(image, { autoAlpha: 0 });
  }

  tl
    .to(kgNum, { xPercent: 0, autoAlpha: 1, duration: 1 })
    .to(lineOne, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=0.75")
    .to(lineTwo, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=0.75")
    .to(lineThree, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=0.35")
    .to(button, { xPercent: 0, autoAlpha: 1, duration: 1 }, "-=0.35")
    .to(image, { autoAlpha: 1, duration: 1 }, "-=1.8")
    .to(allLinks, { y: 0, autoAlpha: 1, scale: 1, stagger: 0.4, rotationX: 0 });
}

const sections = document.querySelectorAll(".k-row-1");
sections.forEach((section) => {
  createTextRevealAnimation(section);
});

// ==========================================
// kg-h2-p-text-section.js 
// ==========================================

function initKgH2PTextSection() {
  document.querySelectorAll(".kg-text-content").forEach((section, index) => {
    const sectionId = `.section-${index + 1}`;

    gsap.timeline({
      scrollTrigger: {
        trigger: section,
        start: "top 80%",
        end: "bottom bottom",
        toggleActions: "play none none reverse"
      }
    })
      .from(`${sectionId} h2.kg-text-h2`, { opacity: 0, y: 20, duration: 1 })
      .from(`${sectionId} p.kg-text-p`, { opacity: 0, y: 20, duration: 1 }, "-=0.5");
  });
}
